<div class="adviser-card-container">
    @if (isLoading) {
        <nw-expansion-panel
            class="adviser-card-container__panel"
            [config]="expansionPanelConfig"
            (isOpenChange)="onIsCardOpenToggle($event)"
        >
            <section class="adviser-card-container__panel__header" role="header">
                <div
                    class="adviser-card-container__panel__header__loading-icon--small"
                ></div>
                @if (isCardOpen) {
                    <div
                        class="adviser-card-container__panel__header__loading-adviser-name"
                    ></div>
                }
            </section>
            @if (isCardOpen) {
                <section role="body">
                    <div
                        class="adviser-card-container__panel__body__loading-message"
                    ></div>
                </section>
            }
        </nw-expansion-panel>
    } @else {
        <nw-expansion-panel
            class="adviser-card-container__panel"
            [config]="expansionPanelConfig"
            (isOpenChange)="onIsCardOpenToggle($event)"
        >
            <section class="adviser-card-container__panel__header" role="header">
                @if (isDefaultAdviser) {
                    <div
                        class="adviser-card-container__panel__header__icon-headset"
                        [class.adviser-card-container__panel__header__icon-headset--closed]="
                            !isCardOpen
                        "
                    >
                        <nw-icon
                            class="adviser-card-container__panel__header__icon-headset__icon"
                            icon="headset"
                        ></nw-icon>
                    </div>
                } @else {
                    <img
                        [src]="pictureUrl"
                        [alt]="name"
                        class="adviser-card-container__panel__header__specialist-img"
                        [class.adviser-card-container__panel__header__specialist-img--closed]="
                            !isCardOpen
                        "
                    />
                }
                @if (isCardOpen) {
                    <div
                        class="adviser-card-container__panel__header__name-job-title-group"
                    >
                        <span
                            class="adviser-card-container__panel__header__name-job-title-group__adviser-name"
                            >{{ name }}</span
                        >

                        @if (!isDefaultAdviser) {
                            <span
                                class="adviser-card-container__panel__header__name-job-title-group__job-title"
                                >{{ jobTitle }}</span
                            >
                        }
                    </div>
                }
            </section>
            @if (isCardOpen) {
                <section class="adviser-card-container__panel__body" role="body">
                    <span class="adviser-card-container__panel__body__message">
                        Speak to us about planning for the future and reaching your goals
                    </span>

                    <ng-container
                        *ngTemplateOutlet="
                            actionBarTemplate;
                            context: {
                                parentClass: 'adviser-card-container__panel__body'
                            }
                        "
                    ></ng-container>
                </section>
            }
        </nw-expansion-panel>
    }
</div>
<ng-template #actionBarTemplate let-parentClass="parentClass">
    <div class="{{ parentClass }}__action-bar">
        <ng-container *ngTemplateOutlet="actionBar"></ng-container>
    </div>
</ng-template>
